import { createSlice } from '@reduxjs/toolkit';

import { revertAll } from '../actions';

export interface IAppState {
    activeHTTPRequests: number;
    isDarkTheme: boolean;
    session: { [key: string]: unknown };
}

const initialState: IAppState = {
    activeHTTPRequests: 0,
    isDarkTheme: false,
    session: {},
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        showLoader: state => {
            return {
                ...state,
                activeHTTPRequests: state.activeHTTPRequests + 1,
            };
        },
        hideLoader: state => {
            return {
                ...state,
                activeHTTPRequests: state.activeHTTPRequests > 1 ? state.activeHTTPRequests - 1 : 0,
            };
        },
    },
    extraReducers: builder => {
        builder.addCase(revertAll, () => initialState);
    },
});

export const { showLoader, hideLoader } = appSlice.actions;
export const appReducer = appSlice.reducer;
